import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { ClerkProvider, useAuth } from '@clerk/clerk-react'
import { ConvexReactClient } from 'convex/react'
import { ConvexProviderWithClerk } from 'convex/react-clerk'
import { HelmetProvider } from 'react-helmet-async'
import './lib/i18n/i18n' // Initialize i18n before React
import App from './App.tsx'
import { queryClient } from './lib/query-client'
import './index.css'
import { Toaster, ThemeProvider } from '@tonesmith/ui'

// Import Clerk Publishable Key
const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string
const CONVEX_URL = import.meta.env.VITE_CONVEX_URL as string

if (!CLERK_PUBLISHABLE_KEY) {
  throw new Error('Missing VITE_CLERK_PUBLISHABLE_KEY. Please check your .env.local file.')
}

if (!CONVEX_URL) {
  throw new Error('Missing VITE_CONVEX_URL. Please check your .env.local file.')
}

// Initialize Convex client
const convex = new ConvexReactClient(CONVEX_URL)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY}>
        <ConvexProviderWithClerk client={convex} useAuth={useAuth}>
          <QueryClientProvider client={queryClient}>
            <ThemeProvider defaultTheme="system" storageKey="tonesmith-theme">
              <App />
              <Toaster />
            </ThemeProvider>
          </QueryClientProvider>
        </ConvexProviderWithClerk>
      </ClerkProvider>
    </HelmetProvider>
  </React.StrictMode>
)
